
import React from 'react'
import DetailContainer from '../MainPage/common/DetailContainer'
import { images } from '../common/images';

function MoneySpentDetailContainer({ time, moneySpent, showTime=true, name = "Total Money Spent" }) {

  return (
    <DetailContainer
      name={name}
      value={`${moneySpent.toFixed(2)}`}
      time={time}
      showTime={showTime}
      color={"rgba(50, 47, 200, 0.10)"}
      borderColor={"#322FC8"}
      image={images.moneySpent}
    />
  )
}

export default MoneySpentDetailContainer